import React, { useContext, FC } from 'react';

import { Grid, Avatar, Hidden } from '@material-ui/core';

import { GlobalContext } from '../../../../../../store';
import { IRoundGame } from '../../../../../../store/admin/eventRounds/store';

import { userPic } from '../../../../../../assets/images';
import { PlayerInfoStyled } from './PlayerInfo.Styles';
import { toHandicap } from '../../../../../../contrib/Utils/toHandicap';

interface IProps {
  game: IRoundGame | undefined;
}

const PlayerInfo: FC<IProps> = (props: IProps) => {
  const { game } = props;

  const {
    playerEditorModal: { enrollment }
  } = useContext(GlobalContext);

  if (!enrollment) {
    return <></>;
  }

  const {
    user: {
      profile: { image },
      firstName,
      lastName
    }
  } = enrollment;

  return (
    <PlayerInfoStyled>
      <Grid className="grid" container={true} spacing={0}>
        <Grid className="grid-item name" item={true} xs={12} sm={12} md={6}>
          <Avatar
            className="enrollment-avatar"
            src={image || userPic}
            alt={`${firstName} ${lastName} avatar`}
          />

          <div className="player-name">
            <p>{firstName}</p>

            <p>{lastName}</p>
          </div>
        </Grid>

        <Hidden mdUp={true}>
          <Grid className="grid-item handicaps" item={true} xs={3} />
        </Hidden>

        <Grid className={`grid-item handicaps ${game ? '' : 'TBD'}`} item={true} xs={9} md={6}>
          <p>
            COURSE HDCP <span>{game ? toHandicap(game.handicap) : 'TBD'}</span>
          </p>

          <p>
            ADJUSTED HDCP <span>{game ? toHandicap(game.adjustedHandicap) : 'TBD'}</span>
          </p>
        </Grid>
      </Grid>
    </PlayerInfoStyled>
  );
};

export default PlayerInfo;
